import logo from "@/assets/logo-official.png";

// Logo officiel : remplacez src/assets/logo-official.png pour le mettre à jour.
export function Logo({ size = 72 }) {
  return (
    <img
      data-testid="app-logo"
      src={logo}
      alt="Ma Maison Suivie 2.0"
      width={size}
      height={size}
      className="shrink-0 object-cover"
      style={{ width: size, height: size, borderRadius: size / 5 }}
    />
  );
}

export function Brand({ compact }) {
  return (
    <div className="flex items-center gap-3">
      <Logo size={compact ? 40 : 56} />
      <div className="min-w-0">
        <div className={`font-display tracking-[0.5px] text-white ${compact ? "text-base leading-[22px]" : "text-xl leading-[26px]"}`}>
          MA MAISON SUIVIE <span className="text-[#D4AF37]">2.0</span>
        </div>
        {!compact && <div className="t-caption !text-[#C0C0C0]">Accompagnement &amp; coordination de votre projet de construction</div>}
      </div>
    </div>
  );
}
